import magnifiAPIInstance from "./apiInstance";

export const countryAPIs = {
  getCountries: ({ payload }) => magnifiAPIInstance.get(`/api/v3/country/get-countries`, payload),
};
